function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import * as React from 'react';
import { connect } from 'react-redux';
import { getTelemetryDetailContentCurrentView, isSaaS, isOfficeSaasApp } from '@shared/utils/appUtils';
import { PricingStates, CheckoutSource } from '@shared/Models';
import { isAppSource, isEmbed } from '@embed/embedHostUtils';
import { getPrimaryProductUrl } from '@shared/utils/datamappingHelpers';
import { createSetCheckoutSource } from '@shared/actions/checkoutActions';
import { AppTile as AppTileComponent } from '@shared/components/appTile/appTile';
import { withHydration } from '@shared/hooks/useHydration';
// If the Addin has a preview offer in his linkedSaas, we dont need to count them. only the non-preview offers
const previewOffers = '-preview';
const skipPreviewSaaS = (linkedSaas)=>{
    const linkedItemsIds = linkedSaas.map(({ entityId })=>entityId);
    return linkedItemsIds.filter((entityId)=>!entityId.endsWith(previewOffers));
};
const mapStateToProps = (state, ownProps)=>{
    var _ownProps_linkedSaaS;
    const productUrlkey = getPrimaryProductUrl(ownProps.primaryProduct);
    let shouldShowLinkedAddIn = ownProps.shouldShowLinkedAddIn;
    let shouldShowLinkedWebApps = ((_ownProps_linkedSaaS = ownProps.linkedSaaS) === null || _ownProps_linkedSaaS === void 0 ? void 0 : _ownProps_linkedSaaS.length) > 0 && skipPreviewSaaS(ownProps.linkedSaaS).length > 0;
    if (isSaaS(productUrlkey) || isOfficeSaasApp(productUrlkey, ownProps.products)) {
        if ((isAppSource(ownProps.embedHost) || isEmbed(ownProps.embedHost)) && ownProps.linkedAddIns !== undefined && ownProps.linkedAddIns.length > 0) {
            shouldShowLinkedAddIn = true;
            shouldShowLinkedWebApps = false;
        }
    } else if (!(isSaaS(productUrlkey) && isOfficeSaasApp(productUrlkey, ownProps.products)) && shouldShowLinkedWebApps) {
        shouldShowLinkedAddIn = false;
    }
    const { billingCountryCode, correlationId, isEmbedded, currentView, currentGalleryViewIsCurated, isMobile, featureFlags, query, requestId: searchReqId, locale, startingPricingData, privateStartingPricingData } = state.config;
    const { signedIn, profile, loading } = state.users;
    const { ShowPopularity } = featureFlags;
    const { activeFilters: appsActiveFilters, count: appsCount } = state.apps;
    const { activeFilters: servicesActiveFilters, count: servicesCount } = state.services;
    const managedLicenses = (profile === null || profile === void 0 ? void 0 : profile.managedLicenses) || [];
    const doesTenantHasLicenseForApp = managedLicenses.some((x)=>x.productId === ownProps.bigId);
    const startingPrice = isEmbedded && !(ownProps.licenseManagement && ownProps.licenseManagement.isMicrosoftManaged) ? {
        pricingData: PricingStates.AlwaysAvailable
    } : ownProps.isPrivateOffer ? privateStartingPricingData === null || privateStartingPricingData === void 0 ? void 0 : privateStartingPricingData[`${ownProps.entityId}`] : startingPricingData === null || startingPricingData === void 0 ? void 0 : startingPricingData[`${ownProps.entityId}`];
    return _object_spread_props(_object_spread({}, ownProps), {
        billingCountryCode,
        startingPrice,
        tileDataRequestId: state.apps.tileDataRequestId,
        correlationId,
        isEmbedded,
        signedIn,
        currentView: getTelemetryDetailContentCurrentView(currentView, currentGalleryViewIsCurated),
        isMobile,
        showPopularity: ShowPopularity === 'true',
        uiRole: profile && profile.uiRole,
        shouldShowLinkedAddIn,
        shouldShowLinkedWebApps,
        doesTenantHasLicenseForApp,
        isLoadingUserData: loading,
        searchSortingBy: query.sortBy,
        activeFilters: currentView === 'appGallery' ? appsActiveFilters : servicesActiveFilters,
        count: currentView === 'appGallery' ? appsCount : servicesCount,
        searchReqId,
        locale
    });
};
export const mapDispatchToProps = (dispatch)=>{
    return {
        setTileCheckoutSource: ()=>dispatch(createSetCheckoutSource({
                source: CheckoutSource.Tile
            }))
    };
};
export const AppTile = connect(mapStateToProps, mapDispatchToProps)(withHydration(AppTileComponent));
